// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"1b62853a","463":"b514b704","649":"7b998fe5","922":"a1f1c90c","987":"0594bf59"}[chunkId] + ".chunk.js";
};